// ============================================================================
// ITALIAN TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "L'Unità che Produce la Pace",
    author: "Di Emmanuel",
    subtitle: "Ogni religione ha le sue ragioni, i nostri confini vengono dal passato",
    description: "Modulo di riflessione sull'unità spirituale e la pace tra le tradizioni",
    
    nav: {
      intro: "Intro",
      religions: "Religioni",
      common: "Basi Comuni",
      humility: "Umiltà"
    },

    intro: {
      emmanuelSays: "Emmanuel dice:",
      ourBordersFromPast: "I nostri confini vengono dal passato",
      bordersDescription: "Ogni religione ha le sue ragioni. Le nostre divisioni non sono la volontà divina, ma il frutto della storia, della geografia, della cultura.",
      divisionWork: "La divisione, l'isolamento attraverso barriere e confini di paura, è l'opera del nostro passato pericoloso.",
      sharedHumanity: "Siamo nati in tradizioni diverse, ma condividiamo la stessa umanità.",
      
      revelationTitle: "Una rivelazione che apre gli occhi",
      surprisedLearning: "Sono rimasto sorpreso un giorno scoprendo che gli Ebrei sono anche figli di Dio.",
      angelMichael: "Che l'angelo Michele è un grande messaggero per i musulmani.",
      jesusNames: "Che Gesù, Isa, Yeshua sono conosciuti in vari modi, anche nella fede cristiana.",
      diverseTribes: "Perché esistono diverse tribù, diverse chiese, diverse famiglie.",
      sameRealities: "Parliamo delle stesse realtà con nomi diversi. Questo dovrebbe avvicinarci, non dividerci.",
      
      respectTitle: "Il rispetto: base dell'umiltà, custode della pace",
      respectFoundation: "Anche se la fratellanza non è oggettivamente applicabile, il rispetto è la base dell'umiltà, custode della pace.",
      understandingProcess: "Comprendere e rispettare le altre religioni è un processo di umiltà. Ciò non significa rinunciare alla propria fede, ma accettare che anche l'altro cerca la verità.",
      
      whatBindsUs: "Ciò che ci lega veramente",
      seekingRelation: "Ogni religione cerca la relazione. Ogni uomo cerca la pace.",
      loveOfGod: "Questa relazione che ci lega tutti è l'amore di Dio.",
      universalLink: "L'amore è il legame universale che trascende tutti i confini, tutte le lingue, tutte le tradizioni.",
      
      inclusionTitle: "L'inclusione: ancora più vasta della diversità religiosa",
      vastInclusion: "La diversità religiosa è vasta, ma ancora più vasta è l'inclusione degli altri là dove sono chiamati da Dio.",
      respectDifferences: "Il rispetto delle differenze di colore, di genere, l'inclusione ci rende umani unici, amati da Dio.",
      jesusCommand: "Gesù ha detto: 'Amatevi gli uni gli altri.'",
      
      communitySpirit: "Rompere con lo spirito comunitarista",
      communityTerror: "Il comunitarismo è il terrore dell'odio del male mascherato. Trasforma la fede in identità tribale, in muro che separa, in arma che ferisce.",
      pridePolitics: "I nostri spiriti di parte ci spingono alla politica dell'orgoglio:",
      prideQuotes: "Ho ragione a farti del male. Ho ragione e basta. Ho ragione a fare guerra giusta.",
      watchHeart: "Fate attenzione al cuore del problema, alla radice del nostro stesso male.",
      refuseDivision: "Rifiutiamo questa deriva che divide l'umanità in nome di Dio.",
      
      freedomTitle: "Per essere liberi, rendere liberi gli altri",
      freedomOthers: "Per essere liberi, bisogna saper rendere liberi anche gli altri.",
      defendFreedom: "La mia libertà di credere ha valore solo se difendo quella di tutti. Opprimere l'altro significa condannarmi alla servitù.",
      
      changeHeartTitle: "Cambia il tuo cuore: sii una vera lanterna",
      recognizeDecency: "Riconoscere che la decenza non è la stessa per ognuno.",
      changeYourself: "Cambiamento di te per primo, progressivamente. Cambia il tuo cuore, trasforma la tua vita, sii una vera lanterna.",
      beExample: "Non fare pipì sul prato, perché morirà... Non imporre le tue regole agli altri, ma diventa un esempio vivente attraverso la tua trasformazione.",
      
      childrenPeaceTitle: "I nostri figli vivranno in pace nella diversità",
      avoidPursuit: "Evitare l'inseguimento delle parole per parole.",
      peaceChoice: "Se scegliamo il rispetto oggi, i nostri figli del futuro vivranno in pace nella diversità. La pace inizia da noi, ora, nelle nostre parole e azioni.",
      
      discernTitle: "Discernere: l'uomo o Dio?",
      manSpeaks: "Troppe volte è il cuore dell'uomo che parla e divide.",
      seeFruits: "Lo si vede dal frutto delle parole e delle parole: il furto, la distruzione, le guerre. Fate attenzione alla manipolazione delle parole per concorrere al proprio orgoglio.",
      
      lookPeaceTitle: "Guardare alla pace e all'amore",
      lookPeaceAll: "Guardare alla pace per tutti, guardare all'amore di Dio per gli altri.",
      godSpeaks: "Quando le parole producono pace, riconciliazione, unità: è Dio che parla. Quando producono divisione, odio, guerra: è l'orgoglio dell'uomo.",
      
      watchWordsTitle: "Vegliare sulle nostre parole",
      watchShares: "Vegliare sulle nostre condivisioni, vegliare sulle nostre parole contrarie nefaste verso gli altri.",
      disqualify: "Questi mali ci squalificano noi stessi. I frutti delle nostre parole rivelano chi parla in noi: Dio o il nostro orgoglio?",
      
      wisdomMaturityTitle: "Saggezza e maturità di fronte alla nostra natura",
      useScriptures: "Usare le scritture (le leggi) per fare del male è la nostra abitudine, un processo quasi naturale e malizioso.",
      hateSin: "Di fronte alla nostra natura peccatrice, abbiamo in orrore il male e le persone che fanno il male.",
      separateActs: "Ma per saggezza e maturità, bisogna separare gli atti dalla nostra povertà umana.",
      compassionNature: "Riconoscere la nostra natura animale che ha bisogno di compassione e grazia, pur proteggendosi secondo i contesti.",
      
      denounceLeadersTitle: "Denunciare i leader spirituali corrotti",
      watchLeaders: "Fate attenzione ai leader spirituali o dirigenti che cercano di mantenere segreto il loro declino e disonestà.",
      noJustice: "Senza giustizia, nessun esempio. Senza conoscenza, altre vittime periscono per il nostro silenzio.",
      silenceComplicity: "Il silenzio di fronte all'ingiustizia è complicità. La verità deve essere detta per proteggere gli altri."
    },

    religions: {
      title: "Diverse Religioni, un'Umanità",
      intro: "Cristiani, Musulmani, Ebrei, Induisti, Buddhisti... e molti altri: tutti cercano la verità",
      theirGod: "Il loro Dio:",
      theGood: "Il Bene:",
      theEvil: "Il Male:",
      theAngels: "Gli Angeli:",
      theUnity: "L'Unità:",
      values: "Valori:",
    commonGoal: "Obiettivo Comune",
    seekingPeace: "Tutte le religioni condividono un obiettivo comune: cercare la pace, promuovere l'amore e costruire un mondo migliore. Al di là delle nostre differenze, siamo tutti uniti in questa ricerca di saggezza e armonia.",
      
      christianity: {
        name: "Cristianesimo",
        godText: "Un Dio unico, Padre creatore",
        goodText: "L'amore del prossimo, il perdono, la pace",
        evilText: "L'odio, l'egoismo, la violenza",
        angelsText: "I messaggeri di Dio (Gabriele, Michele...)",
        unityText: "Un solo Dio per tutti gli uomini",
        values: "Amore,Perdono,Pace,Umiltà,Giustizia"
      },
      islam: {
        name: "Islam",
        godText: "Allah, l'Unico e Misericordioso",
        goodText: "La giustizia, la carità, la pace",
        evilText: "L'oppressione, la menzogna, la divisione",
        angelsText: "Gli angeli di luce (Jibril, Mikail...)",
        unityText: "Non c'è dio all'infuori di Allah",
        values: "Pace,Giustizia,Carità,Rispetto,Misericordia"
      },
      judaism: {
        name: "Ebraismo",
        godText: "YHWH, l'Eterno unico",
        goodText: "La giustizia, la compassione, la vita",
        evilText: "L'oppressione, la maldicenza, l'odio",
        angelsText: "I messaggeri celesti (Malakhim)",
        unityText: "Ascolta Israele, l'Eterno è Uno",
        values: "Giustizia,Vita,Memoria,Pace,Studio"
      },
      hinduism: {
        name: "Induismo",
        godText: "Brahman, la realtà suprema",
        goodText: "La non-violenza (ahimsa), il dovere giusto",
        evilText: "La violenza, l'ignoranza spirituale",
        angelsText: "I Deva, esseri celesti benevoli",
        unityText: "Tutto è Uno in Brahman",
        values: "Non-violenza,Verità,Compassione,Purezza,Armonia"
      },
      buddhism: {
        name: "Buddhismo",
        godText: "Nessun dio creatore, ma rispetto del sacro",
        goodText: "La compassione, la saggezza, la pace",
        evilText: "La sofferenza causata dall'ignoranza",
        angelsText: "I Bodhisattva, esseri illuminati",
        unityText: "Natura di Buddha in ognuno",
        values: "Compassione,Saggezza,Pace,Non-violenza,Risveglio"
      }
    },

    common: {
      title: "Le Basi Comuni",
      intro: "Il Bene, il Male, gli Angeli, Un Dio Unico, la Relazione, l'Inclusione: ciò che unisce l'umanità",
      
      goodTitle: "Il Bene",
      goodDescription: "Tutte le religioni insegnano l'amore, la giustizia e la compassione",
      goodExamples: "Amare il prossimo come se stessi|Fare il bene senza distinzione|Proteggere i deboli e gli oppressi|Dire la verità con benevolenza|Condividere ciò che si ha",
      
      evilTitle: "Il Male",
      evilDescription: "Tutte condannano la violenza, la menzogna e l'oppressione",
      evilExamples: "Uccidere senza giustizia|Rubare e sfruttare|Mentire e calunniare|Disprezzare e umiliare|Dividere e odiare",
      
      angelsTitle: "Gli Angeli e Esseri Spirituali",
      angelsDescription: "Quasi tutte riconoscono messaggeri celesti benevoli",
      angelsExamples: "Angeli messaggeri di Dio|Guide spirituali|Esseri di luce|Protettori celesti|Bodhisattva e Deva",
      
      godTitle: "Un Dio Unico (o Realtà Suprema)",
      godDescription: "La maggioranza crede in una fonte unica, un creatore o una realtà ultima",
      godExamples: "Cristianesimo, Islam, Ebraismo: Un solo Dio|Induismo: Brahman, l'Uno supremo|Buddhismo: Natura di Buddha universale|Tutti cercano la verità ultima|Tutti aspirano all'unità e alla pace",
      
      relationTitle: "La Relazione e la Pace",
      relationDescription: "Ciò che unisce veramente tutte le religioni e tutti gli uomini",
      relationExamples: "Ogni religione cerca la relazione con il divino|Ogni uomo cerca la pace|Questa relazione che ci lega tutti è l'amore di Dio|L'amore è il legame universale|La pace è la nostra aspirazione comune",
      
      inclusionTitle: "L'Inclusione: Amati da Dio",
      inclusionDescription: "La diversità religiosa è vasta, ma ancora più vasta è l'inclusione",
      inclusionExamples: "Inclusione degli altri là dove sono chiamati da Dio|Rispetto delle differenze di colore|Rispetto delle differenze di genere|L'inclusione ci rende umani unici, amati da Dio|Gesù ha detto: 'Amatevi gli uni gli altri'",
      
      finalQuote: "Sono rimasto sorpreso un giorno scoprendo che gli Ebrei sono anche figli di Dio, che l'angelo Michele è un grande messaggero per i musulmani, che Gesù, Isa, Yeshua sono conosciuti in vari modi anche nella fede cristiana. Perché esistono diverse tribù, diverse chiese, diverse famiglie.",
      finalQuote2: "Parliamo delle stesse realtà con nomi diversi.",
      quoteAuthor: "Emmanuel, L'Unità che Produce la Pace"
    },

    humility: {
      title: "7 Tappe verso l'Umiltà e la Pace",
      intro: "Il processo per superare il comunitarismo e diventare una vera lanterna",
      
      step: "Tappa",
      action: "Azione:",
      
      step1Title: "Riconoscere: i nostri confini vengono dal passato",
      step1Description: "La divisione, l'isolamento attraverso barriere e confini di paura, è l'opera del nostro passato pericoloso. Le nostre divisioni non sono la volontà di Dio.",
      step1Action: "Accettare che la mia tradizione è solo mia, e faccio parte della diversità voluta da Dio",
      
      step2Title: "Il rispetto: base dell'umiltà, custode della pace",
      step2Description: "Anche se la fratellanza non è oggettivamente applicabile, il rispetto è il fondamento.",
      step2Action: "Rispettare tutte le credenze, anche senza capire tutto",
      
      step3Title: "Comprendere senza giudicare",
      step3Description: "Oggi, comprendere gli altri è un processo di umiltà necessario.",
      step3Action: "Ascoltare veramente ciò che credono gli altri, senza giudizio",
      
      step4Title: "Cambiamento di te per primo: sii una vera lanterna",
      step4Description: "Riconoscere che la decenza non è la stessa per ognuno. Cambia il tuo cuore progressivamente, trasforma la tua vita, diventa una vera luce.",
      step4Action: "Non imporre le mie regole agli altri, ma essere un esempio vivente attraverso la mia trasformazione",
      
      step5Title: "Rompere con lo spirito comunitarista",
      step5Description: "I nostri spiriti di parte ci spingono alla politica dell'orgoglio: 'Ho ragione a farti del male, ho ragione e basta.' Fate attenzione al cuore del problema, alla radice del nostro stesso male.",
      step5Action: "Rifiutare i discorsi di divisione nella mia stessa comunità",
      
      step6Title: "Per essere libero, rendere liberi gli altri",
      step6Description: "La mia libertà dipende da quella che concedo agli altri.",
      step6Action: "Difendere la libertà di coscienza di tutti, non solo la mia",
      
      step7Title: "Evitare l'inseguimento delle parole per parole",
      step7Description: "Non rispondere all'odio con l'odio, agli insulti con gli insulti.",
      step7Action: "Scegliere la pace affinché i nostri figli vivano in pace nella diversità",
      
      discernFruits: "Discernere dai Frutti",
      humanHeart: "Il cuore dell'uomo che divide",
      lookGodLove: "Guardare all'amore di Dio",
      watchOurWords: "Vegliare sulle nostre Parole",
      
      prideFruits: "Frutti dell'orgoglio umano",
      prideFruitsList: "Spirito di parte: \"Ho ragione, punto\"|Politica dell'orgoglio: \"Ho ragione di farti del male\"|Usare le scritture per far del male (processo dispettoso)|Odiare le persone (non solo gli atti)|Leader spirituali che nascondono la loro deriva e disonestà|Silenzio complice di fronte all'ingiustizia|Divisione e guerre|Odio mascherato da pietà|Furto e distruzione|Manipolazione per orgoglio|Disprezzo e violenza",
      
      godFruits: "Frutti dell'amore di Dio",
      godFruitsList: "Separare gli atti dalla persona con saggezza|Compassione per la nostra povertà umana|Grazia proteggendoci secondo i contesti|Denunciare l'ingiustizia per proteggere gli altri|Dire la verità con coraggio|Pace per tutti|Amore senza distinzione|Riconciliazione e unità|Umiltà e rispetto|Libertà per tutti",
      
      finalQuote: "Anche se la fratellanza non è oggettivamente applicabile, il rispetto è la base dell'umiltà, custode della pace. Evitare l'inseguimento delle parole per parole, e i nostri figli del futuro vivranno in pace nella diversità.",
      author: "Emmanuel"
    },

    footer: {
      quote: "Il rispetto è la base dell'umiltà, custode della pace. I nostri figli vivranno in pace nella diversità se scegliamo il rispetto oggi.",
      author: "Emmanuel, L'Unità che Produce la Pace"
    }
};

export default unityTranslations;
